// extracted by mini-css-extract-plugin
export default {"modal":"HttpsModal_modal__6ntr5","certificate-grid":"HttpsModal_certificate-grid__p7VPV"};